/**
 * Campus Framework API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@bitapp.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PaginatedResponseMeta { 
    currentPage?: number;
    from?: number;
    lastPage?: number;
    path?: string;
    perPage?: number;
    to?: number;
    total?: number;
    sortName?: string;
    sortType?: PaginatedResponseMetaSortTypeEnum;
}
export enum PaginatedResponseMetaSortTypeEnum {
    Asc = 'asc',
    Desc = 'desc'
};



